<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>ESG Measurement Units</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCsrMeasurementUnitCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateCsrMeasurementUnit()">
        <mat-icon>add</mat-icon>
        Add ESG Measurement Unit
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="csrMeasurementUnits()"
      [columns]="csrMeasurementUnitsColumns"
      [enablePaging]="true"
      [enableMatching]="true"
      [pageSize]="25"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCsrMeasurementUnit($event)"
      (deleteClick)="onDeleteCsrMeasurementUnit($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
